import { Alert, Box, Button } from '@amzn/awsui-components-core';
import React from 'react';
import { FallbackProps } from 'react-error-boundary';

export const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <Box padding="l">
      <Alert
        type="error"
        header="Something went wrong"
        action={
          <Button variant="primary" onClick={resetErrorBoundary}>
            Try again
          </Button>
        }
      >
        {error.message}
      </Alert>
    </Box>
  );
};

export const AppInitializationFailed = (error: any, resetErrorBoundary: any, customMessage: string) => {
  return (
    <Alert
      type="error"
      dismissible={false}
      visible={true}
      header="Error"
      action={<Button onClick={() => window.location.reload()}>Try again</Button>}
    >
      {error.message}
    </Alert>
  );
};
